<template>
  <div class="justify-content-center">

    <div v-if="loading"
         class="col-lg-12">
      <loader class="table-loader"></loader>
    </div>

    <div class="row" v-if="!loading">
      <div class="col-lg-12">
        <h1 class="page-title">{{model.displayName}}</h1>
      </div>
    </div>

    <div class="row" v-show="!loading">
      <h4 class="col-12 row-title pt-2">{{ 'user.list_attached_clients' | trans }}</h4>
      <clients class="col-md-12" v-bind:therapist-id="therapistId" v-on:loading="onLoading"/>
    </div>

    <div class="row" v-show="!loading">
      <h4 class="col-12 row-title pt-4">{{ 'protocol.bids_for_protocols' | trans }}</h4>
      <bids-list class="col-md-12" v-bind:userId="therapistId"/>
    </div>

    <div class="row" v-show="!loading">
      <h4 class="col-12 row-title pt-4">{{ 'protocol.last_measurement_results' | trans }}</h4>
      <measurements class="col-md-12" v-bind:user-id="therapistId"/>
    </div>

  </div>

</template>

<script>

  import TherapistApiManager from '../../api/therapist'
  import Loader from '../../../loader/components/Loader'
  import Clients from './Clients'
  import BidsList from '../../../bids/components/BidsList'
  import Measurements from './Measurements'

  export default {
    name: 'Profile',
    props: {
      therapistId: {
        required: true,
        type: [Number, String],
      },
    },
    data () {
      return {
        model: {},
        state: {
          loadingCount: 0,
        },
      }
    },
    async created () {
      this.model = await this.fetchData()
    },
    components: {Measurements, BidsList, Clients, Loader},
    computed: {
      loading: {
        get: function () {
          return this.state.loadingCount > 0
        },
        set: function (newVal) {
          if (newVal === false) {
            this.state.loadingCount--
            return
          }

          this.state.loadingCount++
        },
      },
    },
    methods: {
      setLoading: function (state) {
        this.loading = state
      },
      fetchData: async function () {
        try {
          this.setLoading(true)
          let response = await TherapistApiManager.findById({id: this.therapistId})
          return response.data.data
        } catch (e) {
          console.error(e)
        } finally {
          this.setLoading(false)
        }
      },
      onLoading: function (val, created) {
        if (created === false) {
          this.loading = val
        }
      },
    },
  }

</script>



// WEBPACK FOOTER //
// src/modules/user/therapist/profile/Profile.vue